import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface SingleStoryImagelessHeadlineStoryIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items,
}: SingleStoryImagelessHeadlineStoryIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["headline"]);
}
